import React from "react";
import { Module } from "../Model/Module";
import { PlateAddress } from "../Model/PlateAddress";
import { EModuleType } from "../Model/EModuleType";
import {
  EPlateErrorStatus,
  EPlateImagingStatus,
  Plate,
  CanMovePlate,
} from "../Model/Plate";
import { ModuleState, SuiteState } from "../Model/ModuleState";
import LightPathUtil from "./LightPathUtil";
import { EImagingMode } from "../Model/EImagingMode";
import { EFootprint } from "../Model/PlateType";
import { FilterProps } from "react-table";
import { SelectColumnFilter } from "../components/Common/CommonTable";
import { verify } from "crypto";

class PlateUtil {
  // static canMovePlate(plateAddressesToTransfer: PlateAddress[], allPlateAddresses: PlateAddress[]): CanMovePlate[] {

  //   if( plateAddressesToTransfer.length == 0 )
  //     {
  //       return [];
  //     }

  //     const plateAddressesGroupByModuleIdentifier: { [index: PlateAddress[]]: boolean } = plateAddressesToTransfer.reduce(
  //       (map: { [index: string]: PlateAddress[] }, obj: PlateAddress) => (
  //         (map[obj.moduleIdentifier] = [...map[obj.moduleIdentifier],obj]), map
  //       ),
  //       {}
  //     );


  //     //contain multiple module identifier, cannot move to anywhere
  //     if( Object.keys(plateAddressesGroupByModuleIdentifier).length > 1 )
  //     {
  //       return [];
  //     }

  //     const hasEmptyPlate = plateAddressesToTransfer.filter( p => p.usedByPlate == null ).length > 0;

  //     //contain empty plate address, cannot move to anywhere
  //     if( hasEmptyPlate )
  //     {
  //       return [];
  //     }

  //     const sourceModuleIdentifier = Object.keys(plateAddressesGroupByModuleIdentifier)[0];
  //     const sourceModuleType = _moduleRepository.GetModuleType( sourceModuleIdentifier );

  //     List<CanMovePlateDto> result = new List<CanMovePlateDto>();

  //     IModule[] targetModules = _moduleRepository.GetAllModules();

  //     foreach( IModule targetModule in targetModules )
  //     {
  //       bool canMove = false;

  //       if( sourceModuleType != targetModule.ModuleType )
  //       {
  //         switch( targetModule.ModuleType )
  //         {
  //           case EModuleType.IMAGER:
  //             {
  //               canMove = CanMovePlateToImager( targetModule.Identifier, plateAddressesToTransfer );
  //               break;
  //             }
  //           case EModuleType.CHAMBER:
  //             {
  //               canMove = CanMovePlateToStorage( sourceModuleIdentifier, sourceModuleType, plateAddressesToTransfer );
  //               break;
  //             }
  //           case EModuleType.LOADPORT:
  //             {
  //               canMove = CanMovePlateToLoadPort( sourceModuleIdentifier, sourceModuleType, plateAddressesToTransfer );
  //               break;
  //             }
  //           default:
  //             {
  //               canMove = false;
  //               break;
  //             }
  //         }
  //       }

  //       result.Add( new CanMovePlateDto
  //       {
  //         ModuleIdentifier = targetModule.Identifier,
  //         CanMove = canMove
  //       } );
  //     }

  //     return ResultWithValue.Ok( result.ToArray() );

  //     EXIT:

  //     return ResultWithValue.Ok( Array.Empty<CanMovePlateDto>() );


  // }

  static isAllUsedByPlateOk(plateAddresses: PlateAddress[]) {
    for (let i = 0; i < plateAddresses.length; i++) {
      var plateAddress = plateAddresses[i];
      if (plateAddress.usedByPlate != null) {
        if (plateAddress.usedByPlate.errorStatus !== EPlateErrorStatus.OK) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }

  static isAllUsedByOrReservedByPlateOk(plateAddresses: PlateAddress[]) {
    for (let i = 0; i < plateAddresses.length; i++) {
      var plateAddress = plateAddresses[i];

      var plate = plateAddress.usedByPlate ?? plateAddress.reservedByPlate;
      if (plate == null || plate.errorStatus !== EPlateErrorStatus.OK) {
        return false;
      }
    }
    return true;
  }

  static getReservedPlateAddress(plate: Plate, plateAddresses: PlateAddress[]) {
    for (let i = 0; i < plateAddresses.length; i++) {
      if (
        plateAddresses[i].reservedByPlate != null &&
        plateAddresses[i].reservedByPlate?.id === plate.id
      ) {
        return plateAddresses[i];
      }
    }

    return null;
  }

  static getPlateAddressLocation(
    moduleStateById: { [moduleId: string]: ModuleState },
    moduleById: { [moduleId: string]: Module },
    plateAddress: PlateAddress
  ): string {
    const module = moduleById[plateAddress.moduleIdentifier];
    if (module.moduleType === EModuleType.IMAGER) {
      const imagerState = moduleStateById[module.identifier].imager;
      if (imagerState == null) {
        throw new Error("Imager state is null");
      }
      return `IM_${LightPathUtil.toAbbreviation(imagerState.activeLightPath)}`;
    }

    if (module.moduleType === EModuleType.LOADPORT) {
      return `LP_H${plateAddress.hotelNo}_S${plateAddress.slotNo}`;
    }

    if (module.moduleType === EModuleType.CHAMBER) {
      return `ST_H${plateAddress.hotelNo}_S${plateAddress.slotNo}`;
    }

    if (module.moduleType === EModuleType.PSR) {
      return "In Transit";
    }

    return "ERROR";
  }

  static getPlateAddressStatus(
    plate: Plate,
    plateBarcodesOnImager: string[] = [],
    plateBarcodesOnPsr: string[] = []
  ): string {
    if (plate === null || plate === undefined) {
      return "";
    }

    if (plate.errorStatus === EPlateErrorStatus.DuplicateBarcode) {
      return "Duplicate";
    }

    if (
        (plate.errorStatus & (EPlateErrorStatus.Querying as number)) ===
        EPlateErrorStatus.Querying
    ) {
      return "Querying";
    }

    if (plate.errorStatus !== EPlateErrorStatus.OK) {
      return "ERROR";
    }

    if (plateBarcodesOnImager.includes(plate.barcode)) {
      if (plate.imagingStatus === EPlateImagingStatus.Imaging) {
        return "Imaging";
      }

      if (plate.imagingStatus === EPlateImagingStatus.Overview) {
        return "Overview";
      }

      return "On Imager";
    }

    if (plateBarcodesOnPsr.includes(plate.barcode)) {
      return "In Transit";
    }

    if (
      (plate.errorStatus & (EPlateErrorStatus.UnknownPlate as number)) ===
      EPlateErrorStatus.UnknownPlate
    ) {
      return "Unknown";
    }

    if (plate.isExpired) {
      return "Expired";
    }

    return "Active";
  }

  static getPlateAdressStatusFilter() {
    return [
      "Active",
      "Imaging",
      "Overview",
      "On Imager",
      "In Transit",
      "Unknown",
      "Duplicate",
      "Expired",
      "ERROR",
      "Querying",
    ];
  }

  static getPlateAddressRowStyle(
    moduleById: { [moduleId: string]: Module },
    plateAddress: PlateAddress,
    isSelected: boolean,
    plateBarcodesOnImager: string[] = [],
    plateBarcodesOnPsr: string[] = []
  ): React.CSSProperties {
    let style: React.CSSProperties = {};
    if (isSelected) {
      style.background = "#F7A246";
      style.color = "white";
      return style;
    }
    const plate = plateAddress.usedByPlate;

    const module = moduleById[plateAddress.moduleIdentifier];

    if (
      module.moduleType === EModuleType.LOADPORT &&
      plateAddress.usedByPlate == null &&
      plateAddress.reservedByPlate != null
    ) {
      if (plateBarcodesOnPsr.includes(plateAddress.reservedByPlate.barcode)) {
        return {
          color: "green",
          // background: "white",
        };
      } else if (
        plateBarcodesOnImager.includes(plateAddress.reservedByPlate.barcode)
      ) {
        return {
          color:
            plateAddress.reservedByPlate.errorStatus === EPlateErrorStatus.OK
              ? "black"
              : "red",
          background: "#FFFF99",
        };
      }
    }

    if (plate === null || plate === undefined) {
      return style;
    }

    if (module.moduleType === EModuleType.PSR) {
      return {
        color: "green",
        // background: "white",
      };
    }

    if (module.moduleType === EModuleType.IMAGER) {
      return {
        color:
          plateAddress.usedByPlate?.errorStatus === EPlateErrorStatus.OK
            ? "black"
            : "red",
        background: "#FFFF99",
      };
    }

    if (plate.isQueuedForTransfer) {
      return {
        color: "orange",
        // background: "white",
      };
    }

    if (plate.errorStatus !== EPlateErrorStatus.OK) {
      return {
        color: "red",
        // background: "white",
      };
    }

    if (plate.isExpired) {
      return {
        color: "grey",
        // background: "white",
      };
    }

    return {};
  }

  // static IsPlateAddressesCanMoveToLoadPort(
  //   plateAddresses: PlateAddress[],
  //   moduleById: { [index: string]: Module }
  // ) {
  //   let moduleTypeFound: EModuleType | null = null;
  //   for (let i = 0; i < plateAddresses.length; i++) {
  //     const plateAddress = plateAddresses[i];
  //     const moduleType = moduleById[plateAddress.moduleIdentifier].moduleType;
  //     if (moduleType === EModuleType.LOADPORT) {
  //       //some plate already on loadport
  //       return false;
  //     }
  //     if (moduleTypeFound === null) {
  //       moduleTypeFound = moduleType;
  //     }
  //     if (moduleType !== moduleTypeFound) {
  //       //contain multiple module type
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  // static IsPlateAddressesCanMoveToImager(
  //   plateAddresses: PlateAddress[],
  //   imagers: string[],
  //   isSuiteInAutomaticMode: boolean
  // ) {
  //   if (plateAddresses.length !== 1) return false;

  //   if (isSuiteInAutomaticMode) return false;

  //   let otherImagerAvailable = false;
  //   for (let i = 0; i < imagers.length; i++) {
  //     if (imagers[i] !== plateAddresses[0].moduleIdentifier) {
  //       otherImagerAvailable = true;
  //       break;
  //     }
  //   }
  //   return otherImagerAvailable;
  // }

  // static IsPlateAddressesCanMoveToChamber(
  //   plateAddresses: PlateAddress[],
  //   moduleById: { [index: string]: Module }
  // ) {
  //   let moduleTypeFound: EModuleType | null = null;
  //   for (let i = 0; i < plateAddresses.length; i++) {
  //     const plateAddress = plateAddresses[i];
  //     const moduleType = moduleById[plateAddress.moduleIdentifier].moduleType;
  //     if (moduleType === EModuleType.CHAMBER) {
  //       //some plate already on chamber
  //       return false;
  //     }
  //     if (moduleTypeFound === null) {
  //       moduleTypeFound = moduleType;
  //     }
  //     if (moduleType !== moduleTypeFound) {
  //       //contain multiple module type
  //       return false;
  //     }
  //     //chamber only support sbs plate
  //     if (plateAddress.usedByPlate?.plateType?.footprint !== EFootprint.SBS) {
  //       return false;
  //     }
  //   }
  //   return true;
  // }
}

export default PlateUtil;
